import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '审批编号',
      prop: 'id',
      display: false,
      search: false,
    },
    {
      label: '标题',
      prop: 'flowableTitle',
      type: 'input',
      search: false,
      // searchPlaceholder: '请输入标题',
      display: false,
    },
    {
      label: '所属代理商',
      prop: 'startUserBusinessDeptName',
      span: 24,
      display: false,
    },
    {
      label: '签批类型',
      prop: 'processDefinitionKeyName',
      type: 'select',
    },
    {
      label: '租赁人',
      prop: 'customerName',
      type: 'input',
    },
    // {
    //   label: 'id',
    //   prop: 'id',
    //   display: false,
    //   hide: true,
    // },
    {
      label: '申请时间',
      width: 90,
      prop: 'flowableStartTime',
      type: 'input',
    },
    {
      label: '申请人',
      prop: 'startUserName',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '状态',
      prop: 'flowablePassResult',
      display: false,
      type: 'select',
      search: false,
      hide: true,
      dicData: [
        {
          label: '审核通过',
          value: true,
        },
        {
          label: '审核不通过',
          value: false,
        },
      ],
    },
    {
      label: '状态',
      prop: 'flowableStatus',
      display: false,
      type: 'select',
      search: false,
      dicData: [
        {
          label: '未开始',
          value: 1,
        },
        {
          label: '进行中',
          value: 2,
        },
        {
          label: '已结束',
          value: 3,
        },
      ],
    },
    {
      label: '审核时间',
      prop: 'flowableEndTime',
      type: 'date',
      searchRange: true,
      valueFormat:'yyyy-MM-dd',
      display: false,
      search: false,
      hide: true,
    },
    {
      label: '备注',
      prop: 'remark',
      span: 24,
      minWidth: 200,
      display: false,
    },
    {
      label: '签批类型',
      prop: 'processDefinitionKey',
      type: 'select',
      search: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'processDefinitionKeyName',
        value: 'processDefinitionKey',
      },
    },
    {
      label: '申请人',
      prop: 'applyUser',
      type: 'input',
      search: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
    },
  ],
};
